import uuid from './uuid';
import store from './store';
import { setGenderTheme } from './helpers';
import {
  clearUserData,
  setPurchasableUuidInGetItNowButton,
  setRightCustomerUuidOnGetItNowButtonWhenLoadFromCache,
  urlContainsUUID,
} from './common';
import { updateGender } from './genderThemeUpdate';

store.storeCustomerUuid(window.getCustomerUuid() || uuid.v4());
document.addEventListener('DOMContentLoaded', () => {
  backEndVars.gender && updateGender();
  const genderChosen = store.getAnswers().bodyClass || store.get('bodyClass') || 'woman-theme';

  setGenderTheme(genderChosen);
  setPurchasableUuidInGetItNowButton();
  setRightCustomerUuidOnGetItNowButtonWhenLoadFromCache();

  document.querySelectorAll('a[data-e2e="burger-menu-sign-in"]').forEach(function (button) {
    let url = new URL(button.href);
    url.searchParams.append('cid', localStorage.getItem('__cid'));
    button.setAttribute('href', url);
  });
});

// If user reaches one of the final pages clear localstorage from inappropriate data
urlContainsUUID() && clearUserData();
